





























import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import SuggestedChannels from "@/components/dashboard/widgets/SuggestedChannels.vue";
import { NewsRenderCredentials } from "@/services/dashboard/types";
import { getNewsRenderCredentials } from "@/services/dashboard/dashboardService";
import { Cultures } from "@/services/users/types";

const namespace: string = "authentication";

@Component({
    components: {
        // "create-item": CreateItem,
        "suggested-channels": SuggestedChannels
        // news: News,
        // status: Status
    }
})
export default class Dashboard extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    // local
    newsRenderCred = {} as NewsRenderCredentials;
    cultures = Cultures;
    culture = Cultures[0].text;

    // lifecycle hooks
    created() {
        var lang = this.cultures.find(x => x.code === this.getCurrentUser.cultureCode);
        this.culture = lang ? lang.text : this.cultures[0].text;
        getNewsRenderCredentials(new Date(), this.culture).then(data => {
            this.newsRenderCred = data;
        });
    }

    get newsRenderUri() {
        return `${this.newsRenderCred.adminUrl.replace("/api/", "")}/newsRender/${this.newsRenderCred.instanceId}/${this.culture}/${this.newsRenderCred.newsRenderApiKey}`;
    }
}
